<div class="container">
  <div class="close-btn">
    <mat-icon (click)="navigateTo()">close</mat-icon>
  </div>
  <div class="mobile" style="width: 100%">
    <app-background></app-background>
    <app-logo [showMenuIcon]="false"></app-logo>
    <div class="main-container">
      <div class="main-container--row justify-center">
        @for (menuItem of mobileMenu(); track menuItem.navName) {
          <div class="main-container--row--column main-col-12 justify-center">
            <!-- Link zewnetrzny (sklep) osobno: RouterLink z null czysci href na tym samym <a>. -->
            @if (menuItem.webLink) {
              <a class="selection" [href]="menuItem.webLink" (click)="navigateTo()">
                <span style="text-align: center" [innerHTML]="menuItem.navName | translate"></span>
              </a>
            } @else {
              <a
                class="selection"
                [routerLink]="menuItem.routerLink"
                routerLinkActive="router-link-active"
                (click)="navigateTo()"
                >
                <span style="text-align: center" [innerHTML]="menuItem.navName | translate"></span>
              </a>
            }
          </div>
        }
        <div
          class="phone-container mobile-phone main-container--row--column main-col-12 justify-center">
          <a href="tel:603900600">
            <img
              style="width: 260px;"
              src="./assets/tel%20foot.svg"
              [alt]="'common.contactPhone' | translate"
              />
          </a>
        </div>
      </div>
    </div>
  </div>
  <div class="main-container desktop" style="margin-top: 77px">
    <div class="main-container--row justify-center" style="align-items: center;height: calc(100vh - 77px);">
      <div class="main-container--row--column main-col-6 main-col-lg-6 main-col-md-12 main-col-sm-12 main-col-xs-12">
        <div class="main-container--row justify-center">
          @for (menuItem of menu(); track menuItem.navName) {
            <div class="main-container--row justify-center main-col-4 main-col-xs-6">
              <app-routing-button
                (click)="navigateTo()"
                [buttonImageSrc]="menuItem.buttonImageSrc"
                [navName]="menuItem.navName"
                [routerLink]="menuItem.routerLink"
                [imageAlt]="menuItem.imageAlt"
                [link]="menuItem.link"
              ></app-routing-button>
            </div>
          }
          <div
            class="main-container--row--column justify-center main-col-12 main-col-lg-12 main-col-md-12 main-col-sm-12 main-col-xs-12">
            <button (click)="navigateTo();navigateToNews()" class="news-btn">
              {{ 'common.news' | translate }}
            </button>
          </div>
          <div
            class="phone-container main-container--row--column main-col-12 justify-center">
            <a href="tel:603900600">
              <img
                style="width: 260px;"
                src="./assets/tel%20foot.svg"
                [alt]="'common.contactPhone' | translate"
                />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
